<app-dialog-header [title]="data.title" (onClose)="cancel()"></app-dialog-header>

<div class="p-3">
  <!-- Mode selection step -->
  @if (mode === 'choose') {
    <p class="mb-3">
      {{ 'SALES.ORDERS.DETAILS.DIALOG.BULK-CREDIT.CREDITABLE-COUNT' | translate: { count: totalCreditable } }}
    </p>
    <h5 class="mb-3">{{ 'SALES.ORDERS.DETAILS.DIALOG.BULK-CREDIT.MODE-SELECT.TITLE' | translate }}</h5>
    <div class="d-flex gap-2">
      <button class="btn btn-primary" (click)="selectMode('manual')">
        <i class="fas fa-check-square me-1"></i>
        {{ 'SALES.ORDERS.DETAILS.DIALOG.BULK-CREDIT.MODE.MANUAL' | translate }}
      </button>
      <button class="btn btn-primary" (click)="selectMode('amount')">
        <i class="fas fa-sort-numeric-up me-1"></i>
        {{ 'SALES.ORDERS.DETAILS.DIALOG.BULK-CREDIT.MODE.AMOUNT' | translate }}
      </button>
    </div>
  }

  @if (mode !== 'choose') {
    <div class="mb-3">
      <button class="btn btn-sm btn-outline-secondary" (click)="selectMode('choose')">
        <i class="fas fa-arrow-left me-1"></i>{{ 'GENERIC.BUTTON.BACK' | translate }}
      </button>
    </div>
  }

  <!-- Manual selection mode -->
  @if (mode === 'manual') {
    <t4-list-view #listVw [options]="listOptions" (onDataRequest)="onPageChange($event)">
      <ng-container *t4ImportantItemFilter class="w-100">
        <input type="checkbox" [checked]="allSelected" (change)="toggleSelectAll($any($event.target).checked)">
        <span class="ms-1">{{ 'SALES.ORDERS.DETAILS.DIALOG.BULK-CREDIT.SELECT-ALL' | translate }}</span>
      </ng-container>
      <ng-container *t4ListActions>
        <span class="badge bg-primary">
          {{ 'SALES.ORDERS.DETAILS.DIALOG.BULK-CREDIT.SELECTED-COUNT' | translate:{ count: selectedLines.length } }}
        </span>
      </ng-container>
      <ng-container *t4ListItem="let line">
        <td>
          <input type="checkbox" [checked]="isSelected(line)" (change)="toggleSelection(line)" (click)="$event.stopPropagation()">
        </td>
        <td>{{ line.EventName || line.PassePartoutName || line.MembershipName || (line.CrossSellProductName | translate) }}</td>
        <td>{{ line.ParentSectionName }} / {{ line.RowNumber | replaceOnEmpty }} / {{ line.SeatNumber | replaceOnEmpty }}</td>
        <td>{{ line.TicketTypeName || '-' }}</td>
        <td>{{ line.TicketCustomerCalculatedName || '-' }}</td>
        <td class="text-end">{{ line.Total | localCurrency }}</td>
      </ng-container>
    </t4-list-view>
  }

  <!-- Amount mode -->
  @if (mode === 'amount') {
    <div class="form-group">
      <label>{{ 'SALES.ORDERS.DETAILS.DIALOG.BULK-CREDIT.AMOUNT-LABEL' | translate:{ total: maxAmountLines } }}</label>
      <input type="number" class="form-control" [(ngModel)]="creditAmount" [min]="1" [max]="maxAmountLines" style="max-width: 200px">
      <small class="form-text text-muted">{{ 'SALES.ORDERS.DETAILS.DIALOG.BULK-CREDIT.AMOUNT-HINT' | translate }}</small>
    </div>
  }

  @if (mode !== 'choose') {
    <div class="mt-3">
      <div class="text-end mt-3">
        <button class="btn btn-danger" [disabled]="mode === 'manual' ? selectedLines.length === 0 : !isAmountValid" (click)="submit()">
          <i class="fas fa-ban me-1"></i>{{ 'SALES.ORDERS.DETAILS.BTN.BULK-CREDIT' | translate }} ({{ mode === 'manual' ? selectedLines.length : creditAmount }})
        </button>
      </div>
    </div>
  }
</div>
